import { useHistory, useLocation } from '@shared/core';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import qs from 'query-string';
import { ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY } from './constants';

/**
 * Generic utilty hook that will handles all search params updates for the accommodations console
 */
export const useUpdateAccommodationsConsoleSearchParams = () => {
  const history = useHistory();
  const location = useLocation();
  const applyAccommodationConsoleSearchParamsToUrl = useEventCallback(
    (args: { searchParams: Record<string, string | null>; actionType: 'replace' | 'push'; locationHash?: string }) => {
      const { searchParams: searchParamOverrides, actionType, locationHash } = args;
      const params = new URLSearchParams(location.search);
      const currentStateQueryParams = params.get(ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY);

      let paramsToApply: { [key: string]: string | string[] | null } = searchParamOverrides;

      if (currentStateQueryParams) {
        // Parse the current query params and merge with the new ones
        // Filters operate independently of the search form, so we need to merge them
        const parsedCurrentQueryParams = qs.parse(currentStateQueryParams);
        paramsToApply = { ...parsedCurrentQueryParams, ...searchParamOverrides };
      }

      params.set(ACCOMMODATIONS_CONSOLE_ROOT_QUERY_PARAM_KEY, qs.stringify(paramsToApply, { skipNull: true, skipEmptyString: true }));

      history[actionType]?.({
        pathname: location.pathname,
        hash: locationHash,
        search: params.toString(),
      });
    },
  );

  return {
    applyAccommodationConsoleSearchParamsToUrl,
  };
};
